const CREATE_ORGANIZATION_DRAWER = {
  TITLE: 'Create organization',
  ACTIONS: {
    CANCEL: 'Cancel',
    CREATE: 'Create',
    CREATING: 'Creating...',
  },
  FIELDS: {
    NAME: {
      LABEL: 'Name *',
      PLACEHOLDER: 'Acme, Inc.',
    },
    DOMAINS: {
      LABEL: 'Domains (optional)',
      PLACEHOLDER: 'acme.com',
      ADD: 'Add',
      PRIMARY_LABEL: 'Primary domain (optional)',
      NO_PRIMARY: 'No primary domain',
      EMPTY_TEXT: 'No domains added yet.',
      REMOVE: 'Remove domain',
    },
    LANGUAGE: {
      LABEL: 'Language *',
      PLACEHOLDER: 'Select a language...',
      SEARCH_PLACEHOLDER: 'Search languages...',
      EMPTY_TEXT: 'No language found.',
    },
    STANDARDS: {
      LABEL: 'Standards',
      PLACEHOLDER: 'Select standards...',
      SEARCH_PLACEHOLDER: 'Search standards...',
      EMPTY_TEXT: 'No standard found.',
    },
    LOGO: {
      LABEL: 'Logo (optional)',
      PREVIEW_ALT: 'Organization logo preview',
      REMOVE: 'Remove',
    },
  },
  ERRORS: {
    NAME_REQUIRED: 'Name is required',
    LANGUAGE_REQUIRED: 'Language is required',
  },
  LANGUAGES: {
    en: 'English',
    es: 'Spanish',
  },
}
export const COCKPIT = {
  CREATE_ORGANIZATION_DRAWER,
}
